import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;
